
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke132aRequest, Sgke132aResponse, Sgke132aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke132aService {

  /**
   * コンストラクタ
   * @param {Sgke132aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke132aService
   */
  constructor(
    public service: Sgke132aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE132A_入金突合明細報告API呼び出し
   * @param {Sgke132aRequest} request 
   * @returns {Observable<Sgke132aResponse>}
   * @memberof UsedSgke132aService
   */
  public doSgke132a(request: Sgke132aRequest): Observable<Sgke132aResponse> {
    return this.service.sgke132aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE132A');
          return throwError(err.message);
        })
      );
  }

}
